import { mapState, mapActions } from 'vuex'
import Header from '@/components/Core/Header'
import Aside from '@/components/Core/Aside'
import Footer from '@/components/Core/Footer'
import Drawer from '@/components/Core/Drawer'

// dialog
import Toast from '@/components/Dialog/Toast'
import Error from '@/components/Dialog/Error'
import Alert from '@/components/Dialog/Alert'
import Confirm from '@/components/Dialog/Confirm'

// modal : core
import SelectFileModal from '@/components/Modal/SelectFileModal'
import SelectServiceScreenModal from '@/components/Modal/SelectServiceScreenModal'
import SelectServiceDeliveryTypeModal from '@/components/Modal/SelectServiceDeliveryTypeModal'
import SelectServiceNoticeTypeModal from '@/components/Modal/SelectServiceNoticeTypeModal'
import SelectServiceRssModal from '@/components/Modal/SelectServiceRssModal'
import SelectVideoChatModal from '@/components/Modal/SelectVideoChatModal'
// modal : view : dashboard
import DashboardRegistAdminNoticeModal from '@/components/Modal/DashboardRegistAdminNoticeModal'
import DashboardConfirmAdminNoticeModal from '@/components/Modal/DashboardConfirmAdminNoticeModal'
// modal : view : masta
import SelectNoticeTypeMstModal from '@/components/Modal/SelectNoticeTypeMstModal'
import SelectServiceTypeModal from '@/components/Modal/SelectServiceTypeModal'
import SelectScreenIdMstModal from '@/components/Modal/SelectScreenIdMstModal'
// modal : view : service
import ServiceRegistDeliveryTypeModal from '@/components/Modal/ServiceRegistDeliveryTypeModal'
import ServiceRegistAttributeGroupModal from '@/components/Modal/ServiceRegistAttributeGroupModal'
import ServiceSelectFunctionModal from '@/components/Modal/ServiceSelectFunctionModal'
import ServiceRegistMailMagazineModal from '@/components/Modal/ServiceRegistMailMagazineModal'
// modal : view : service : contentsSetting
import ServiceContentsCopyModal from '@/components/Modal/ServiceContentsCopyModal'
import ServiceContentsRegistSnapshotModal from '@/components/Modal/ServiceContentsRegistSnapshotModal'
import ServiceContentsRegistScreenModal from '@/components/Modal/ServiceContentsRegistScreenModal'
import ServiceContentsRegistKeyAssignModal from '@/components/Modal/ServiceContentsRegistKeyAssignModal'
import SelectServiceContentsScreenModal from '@/components/Modal/SelectServiceContentsScreenModal'
// modal : view : service : contentsApply
import ServiceContentsApplyConfirmModal from '@/components/Modal/ServiceContentsApplyConfirmModal'
import ServiceContentsApplyRegistModal from '@/components/Modal/ServiceContentsApplyRegistModal'
import ServiceContentsApplySortModal from '@/components/Modal/ServiceContentsApplySortModal'
// modal : view : file
import FileSelectServiceModal from '@/components/Modal/FileSelectServiceModal'
// modal : view : bot
import BotDestinationModal from '@/components/Modal/BotDestinationModal'
// modal : view : user
import AccountSelectLinkedCmsModal from '@/components/Modal/AccountSelectLinkedCmsModal'
// modal : view : notice
import NoticeDeliveryStatusModal from '@/components/Modal/NoticeDeliveryStatusModal'
import NoticeTestDeliveryModal from '@/components/Modal/NoticeTestDeliveryModal'
// modal : view : log
import LogStatusModal from '@/components/Modal/LogStatusModal'
// modal : view : device
import DeviceRegistResolutionModal from '@/components/Modal/DeviceRegistResolutionModal'
// modal : view : videoChat
import VideoChatModifyModal from '@/components/Modal/VideoChatModifyModal'

// screenConfigLayout
import ScreenConfigLayout from '@/components/ScreenConfigLayout'
import SclHeaderModule from '@/components/ScreenConfigLayout/HeaderModule'
import SclSlideshowModule from '@/components/ScreenConfigLayout/SlideshowModule'
import SclWeatherModule from '@/components/ScreenConfigLayout/WeatherModule'
import SclFortuneModule from '@/components/ScreenConfigLayout/FortuneModule'
import SclCalenderModule from '@/components/ScreenConfigLayout/CalenderModule'
import SclButtonModule from '@/components/ScreenConfigLayout/ButtonModule'
import SclListModule from '@/components/ScreenConfigLayout/ListModule'
import SclLabelModule from '@/components/ScreenConfigLayout/LabelModule'
import SclImageModule from '@/components/ScreenConfigLayout/ImageModule'
import SclPanelModule from '@/components/ScreenConfigLayout/PanelModule'
import SclZIndexModule from '@/components/ScreenConfigLayout/ZIndexModule'

// utils
import Constants from '@/utils/Constants'

export default {
  name: 'App',
  components: {
    Header,
    Aside,
    Footer,
    Drawer,

    // dialog
    Toast,
    Error,
    Alert,
    Confirm,

    // modal : core
    SelectFileModal,
    SelectServiceScreenModal,
    SelectServiceDeliveryTypeModal,
    SelectServiceNoticeTypeModal,
    SelectServiceRssModal,
    SelectVideoChatModal,

    // modal : view
    DashboardRegistAdminNoticeModal,
    DashboardConfirmAdminNoticeModal,
    SelectNoticeTypeMstModal,
    SelectServiceTypeModal,
    SelectScreenIdMstModal,
    ServiceRegistDeliveryTypeModal,
    ServiceRegistAttributeGroupModal,
    ServiceSelectFunctionModal,
    ServiceRegistMailMagazineModal,
    // modal : view : service : contentsSetting
    ServiceContentsCopyModal,
    ServiceContentsRegistSnapshotModal,
    ServiceContentsRegistScreenModal,
    ServiceContentsRegistKeyAssignModal,
    ServiceContentsApplyConfirmModal,
    ServiceContentsApplyRegistModal,
    SelectServiceContentsScreenModal,
    ServiceContentsApplySortModal,
    // modal :
    FileSelectServiceModal,
    BotDestinationModal,
    AccountSelectLinkedCmsModal,
    NoticeDeliveryStatusModal,
    NoticeTestDeliveryModal,
    LogStatusModal,
    DeviceRegistResolutionModal,
    VideoChatModifyModal,

    // screenConfigLayout
    ScreenConfigLayout,
    SclHeaderModule,
    SclSlideshowModule,
    SclWeatherModule,
    SclFortuneModule,
    SclCalenderModule,
    SclButtonModule,
    SclListModule,
    SclLabelModule,
    SclImageModule,
    SclPanelModule,
    SclZIndexModule
  },
  data () {
    return {
      active: false,
      fixedScrollTop: 0
    }
  },
  mounted () {
    console.log('ENV:', process.env.NODE_ENV)
    console.log('VERSION:', process.env.VUE_APP_VERSION)
    console.log('APP KEY:', process.env.VUE_APP_KEY)

    this.active = false

    this.$nextTick(() => {
      if (this.$route.meta.requiresAuth) {
        // ローカルストレージに前回保存したユーザー情報があれば
        if (window.localStorage.user) {
          this.setPermission()
          this.active = true

        } else {
          this.signout()
            .then(() => {
              this.$router.push({
                name: 'Signin'
              })
              this.active = true
            })
        }

      } else {
        if (window.localStorage.user) {
          this.setPermission()
        }
        this.active = true
      }
    })

    // resize
    $(window).on({
      resize: this.onResize
    })
    this.onResize()
  },
  computed: {
    ...mapState({
      authorized: state => state.auth.authorized,
      activeModalCover: state => state.core.activeModalCover,
      activeVideoChatModalCover: state => state.core.activeVideoChatModalCover,
      activeDialogCover: state => state.core.activeDialogCover,
      activeSclCover: state => state.core.activeSclCover,
      activeDrawer: state => state.core.activeDrawer,
      activeGlobalMenu: state => state.core.activeGlobalMenu,
      isBot: state => state.noticeList.isBot,

      // dialog
      activeToast: state => state.toast.active,
      activeError: state => state.error.active,
      activeAlert: state => state.alert.active,
      activeConfirm: state => state.confirm.active,

      // modal : core
      activeSelectFileModal: state => state.selectFileModal.active,
      activeSelectServiceScreenModal: state => state.selectServiceScreenModal.active,
      activeSelectServiceDeliveryTypeModal: state => state.selectServiceDeliveryTypeModal.active,
      activeSelectServiceNoticeTypeModal: state => state.selectServiceNoticeTypeModal.active,
      activeSelectServiceRssModal: state => state.selectServiceRssModal.active,
      activeSelectVideoChatModal: state => state.selectVideoChatModal.active,

      // modal : dashboard
      activeDashboardRegistAdminNoticeModal: state => state.dashboardRegistAdminNoticeModal.active,
      activeDashboardConfirmAdminNoticeModal: state => state.dashboardConfirmAdminNoticeModal.active,

      // modal : masta
      activeSelectNoticeTypeMstModal: state => state.selectNoticeTypeMstModal.active,
      activeSelectServiceTypeModal: state => state.selectServiceTypeModal.active,
      activeSelectScreenIdMstModal: state => state.selectScreenIdMstModal.active,

      // modal : service
      activeServiceRegistDeliveryTypeModal: state => state.serviceRegistDeliveryTypeModal.active,
      activeServiceRegistAttributeGroupModal: state => state.serviceRegistAttributeGroupModal.active,
      activeServiceSelectFunctionModal: state => state.serviceSelectFunctionModal.active,
      activeServiceRegistMailMagazineModal: state => state.serviceRegistMailMagazineModal.active,

      // modal : service : contentsSetting
      activeServiceContentsCopyModal: state => state.serviceContentsCopyModal.active,
      activeServiceContentsRegistSnapshotModal: state => state.serviceContentsRegistSnapshotModal.active,
      activeServiceContentsRegistScreenModal: state => state.serviceContentsRegistScreenModal.active,
      activeServiceContentsRegistKeyAssignModal: state => state.serviceContentsRegistKeyAssignModal.active,
      activeSelectServiceContentsScreenModal: state => state.selectServiceContentsScreenModal.active,

      // modal : service : contentsApply
      activeServiceContentsApplyConfirmModal: state => state.serviceContentsApplyConfirmModal.active,
      activeServiceContentsApplyRegistModal: state => state.serviceContentsApplyRegistModal.active,
      activeServiceContentsApplySortModal: state => state.serviceContentsApplySortModal.active,

      // modal : file
      activeFileSelectServiceModal: state => state.fileSelectServiceModal.active,
      // modal : bot
      activeBotDestinationModal: state => state.botDestinationModal.active,
      // modal : account
      activeAccountSelectLinkedCmsModal: state => state.accountSelectLinkedCmsModal.active,
      // modal : notice
      activeNoticeDeliveryStatusModal: state => state.noticeDeliveryStatusModal.active,
      activeNoticeTestDeliveryModal: state => state.noticeTestDeliveryModal.active,
      // modal : log
      activeLogStatusModal: state => state.logStatusModal.active,
      // modal : device
      activeDeviceRegistResolutionModal: state => state.deviceRegistResolutionModal.active,
      // modal : videoChat
      activeVideoChatModifyModal: state => state.videoChatModifyModal.active,

      // screenConfigLayout
      activeScreenConfigLayout: state => state.screenConfigLayout.active,
      activeSclHeaderModule: state => state.sclHeaderModule.active,
      activeSclSlideshowModule: state => state.sclSlideshowModule.active,
      activeSclWeatherModule: state => state.sclWeatherModule.active,
      activeSclFortuneModule: state => state.sclFortuneModule.active,
      activeSclCalenderModule: state => state.sclCalenderModule.active,
      activeSclButtonModule: state => state.sclButtonModule.active,
      activeSclListModule: state => state.sclListModule.active,
      activeSclLabelModule: state => state.sclLabelModule.active,
      activeSclImageModule: state => state.sclImageModule.active,
      activeSclPanelModule: state => state.sclPanelModule.active,
      activeSclZIndexModule: state => state.sclZIndexModule.active,
    }),
    showFullScreen () {
      if (this.$route.name === 'SetupPassword') return true
      return false
    },
    showHeader () {
      return this.authorized && !this.showFullScreen && !this.isBot
    },
    showAside () {
      return this.authorized && !this.showFullScreen && !this.isBot
    },
    showFooter () {
      return this.authorized && !this.showFullScreen
    },
    showDrawer () {
      return this.activeDrawer
    }
  },
  watch: {
    '$route': function (to) {
      this.hideModalCover()
      this.hideDialogCover()
      this.hideSclCover()
    },
    activeModalCover: function (to) {
      to ? this.destroyScroll() : this.setScroll()
    },
    activeDialogCover: function (to) {
      to ? this.destroyScroll() : this.setScroll()
    },
    activeDrawer: function (to) {
      to ? this.destroyScroll() : this.setScroll()
    }
  },
  methods: {
    ...mapActions({
      signout: 'auth/signout',
      setPermission: 'auth/setPermission',
      changeScreen: 'core/changeScreen',

      // cover
      hideModalCover: 'core/hideModalCover',
      hideDialogCover: 'core/hideDialogCover',
      hideSclCover: 'core/hideSclCover',

      // dialog
      hideAlert: 'alert/hide',
      hideError: 'error/hide',
      hideConfirm: 'confirm/hide',

      // modal : core
      hideSelectFileModal: 'selectFileModal/hide',
      hideSelectServiceScreenModal: 'selectServiceScreenModal/hide',
      hideSelectServiceDeliveryTypeModal: 'selectServiceDeliveryTypeModal/hide',
      hideSelectServiceNoticeTypeModal: 'selectServiceNoticeTypeModal/hide',
      hideSelectServiceRssModal: 'selectServiceRssModal/hide',
      hideSelectVideoChatModal: 'selectVideoChatModal/hide',

      // modal : dashboard
      hideDashboardRegistAdminNoticeModal: 'dashboardRegistAdminNoticeModal/hide',
      hideDashboardConfirmAdminNoticeModal: 'dashboardConfirmAdminNoticeModal/hide',

      // modal : masta
      hideSelectNoticeTypeMstModal: 'selectNoticeTypeMstModal/hide',
      hideSelectServiceTypeModal: 'selectServiceTypeModal/hide',
      hideSelectScreenIdMstModal: 'selectScreenIdMstModal/hide',

      // modal : service
      hideServiceRegistDeliveryTypeModal: 'serviceRegistDeliveryTypeModal/hide',
      hideServiceRegistAttributeGroupModal: 'serviceRegistAttributeGroupModal/hide',
      hideServiceSelectFunctionModal: 'serviceSelectFunctionModal/hide',
      hideServiceRegistMailMagazineModal: 'serviceRegistMailMagazineModal/hide',

      // modal : service : contentsSetting
      hideServiceContentsCopyModal: 'serviceContentsCopyModal/hide',
      hideServiceContentsRegistSnapshotModal: 'serviceContentsRegistSnapshotModal/hide',
      hideServiceContentsRegistScreenModal: 'serviceContentsRegistScreenModal/hide',
      hideServiceContentsRegistKeyAssignModal: 'serviceContentsRegistKeyAssignModal/hide',
      hideSelectServiceContentsScreenModal: 'selectServiceContentsScreenModal/hide',

      // modal : service : contentsApply
      hideServiceContentsApplyConfirmModal: 'serviceContentsApplyConfirmModal/hide',
      hideServiceContentsApplyRegistModal: 'serviceContentsApplyRegistModal/hide',
      hideServiceContentsApplySortModal: 'serviceContentsApplySortModal/hide',

      // modal : file
      hideFileSelectServiceModal: 'fileSelectServiceModal/hide',
      // modal : bot
      hideBotDestinationModal: 'botDestinationModal/hide',
      // modal : account
      hideAccountSelectLinkedCmsModal: 'accountSelectLinkedCmsModal/hide',
      // modal : notice
      hideNoticeDeliveryStatusModal: 'noticeDeliveryStatusModal/hide',
      hideNoticeTestDeliveryModal: 'noticeTestDeliveryModal/hide',
      // modal : log
      hideLogStatusModal: 'logStatusModal/hide',
      // modal : device
      hideDeviceRegistResolutionModal: 'deviceRegistResolutionModal/hide',
      // modal : videoChat
      hideVideoChatModifyModal: 'videoChatModifyModal/hide',

      // screenConfigLayout
      hideScreenConfigLayout: 'screenConfigLayout/hide',
      hideSclHeaderModule: 'sclHeaderModule/hide',
      hideSclSlideshowModule: 'sclSlideshowModule/hide',
      hideSclWeatherModule: 'sclWeatherModule/hide',
      hideSclFortuneModule: 'sclFortuneModule/hide',
      hideSclCalenderModule: 'sclCalenderModule/hide',
      hideSclButtonModule: 'sclButtonModule/hide',
      hideSclListModule: 'sclListModule/hide',
      hideSclLabelModule: 'sclLabelModule/hide',
      hideSclImageModule: 'sclImageModule/hide',
      hideSclPanelModule: 'sclPanelModule/hide',
      hideSclZIndexModule: 'sclZIndexModule/hide',
    }),

    onResize () {
      let windowWidth = window.innerWidth ?
        window.innerWidth : $(window).width()

      if (windowWidth < Constants.Screen.SP) {
        // console.log('mode : SP')
        this.changeScreen('SP')
      } else if (windowWidth < Constants.Screen.TB) {
        // console.log('mode : TB')
        this.changeScreen('TB')
      } else {
        // console.log('mode : PC')
        this.changeScreen('PC')
      }
    },
    // onScroll () {
    //   let scrollTop = $(window).scrollTop()
    // }

    clickModalCover () {
      // modal : core
      this.hideSelectFileModal()
      this.hideSelectServiceScreenModal()
      this.hideSelectServiceDeliveryTypeModal()
      this.hideSelectServiceNoticeTypeModal()
      this.hideSelectServiceRssModal()
      this.hideSelectVideoChatModal()

      // modal : dashboard
      this.hideDashboardRegistAdminNoticeModal()
      this.hideDashboardConfirmAdminNoticeModal()

      // modal : masta
      this.hideSelectNoticeTypeMstModal()
      this.hideSelectServiceTypeModal()
      this.hideSelectScreenIdMstModal()

      // modal : service
      this.hideServiceRegistDeliveryTypeModal()
      this.hideServiceRegistAttributeGroupModal()
      this.hideServiceSelectFunctionModal()
      this.hideServiceRegistMailMagazineModal()

      // modal : service : contentsSetting
      this.hideServiceContentsCopyModal()
      this.hideServiceContentsRegistSnapshotModal()
      this.hideServiceContentsRegistScreenModal()
      this.hideServiceContentsRegistKeyAssignModal()
      this.hideSelectServiceContentsScreenModal()

      // modal : service : contentsApply
      this.hideServiceContentsApplyConfirmModal()
      this.hideServiceContentsApplyRegistModal()
      this.hideServiceContentsApplySortModal()

      // modal : file
      this.hideFileSelectServiceModal()
      // modal : bot
      this.hideBotDestinationModal()
      // modal : account
      this.hideAccountSelectLinkedCmsModal()
      // modal : notice
      this.hideNoticeDeliveryStatusModal()
      this.hideNoticeTestDeliveryModal()
      // modal : log
      this.hideLogStatusModal()
      // modal : device
      this.hideDeviceRegistResolutionModal()
      // modal : video chat
      this.hideVideoChatModifyModal()

      // screenConfigLayout
      this.hideScreenConfigLayout()
    },
    clickVideoChatCover(){
      this.hideSelectVideoChatModal()
    },
    clickDialogCover () {
      this.hideAlert()
      this.hideError()
      this.hideConfirm()
    },
    clickSclCover () {
      this.hideSclHeaderModule()
      this.hideSclSlideshowModule()
      this.hideSclWeatherModule()
      this.hideSclFortuneModule()
      this.hideSclCalenderModule()
      this.hideSclButtonModule()
      this.hideSclListModule()
      this.hideSclLabelModule()
      this.hideSclImageModule()
      this.hideSclPanelModule()
      this.hideSclZIndexModule()
    },

    destroyScroll () {
      this.fixedScrollTop = $(window).scrollTop();
      $(window).scrollTop(0);
      $('#view').css({
        marginTop : -1 * this.fixedScrollTop
      });
      $('#appWrap').addClass('mask');
    },
    setScroll () {
      $('#view').removeAttr('style');
      $('#appWrap').removeClass('mask');
      $(window).scrollTop(this.fixedScrollTop);
    }
  }
}